import { products } from '../../data/homepageData';
import { ResponsiveImage } from '../ui/ResponsiveImage';

export function ProductOverview() {
  return (
    <section id="products" className="section">
      <h2>Naše produkty</h2>
      <div className="product-grid">
        {products.map((product) => (
          <article className="product-card" key={product.id}>
            <ResponsiveImage srcBase={product.image} alt={product.title} className="product-card__image" sizes="(max-width: 768px) 88vw, 260px" />
            <div className="product-card__body">
              <h3>{product.title}</h3>
              <p>{product.text}</p>
              <a href={product.href}>Objevit →</a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
